module.exports = __webpack_public_path__ + "img/160x130.df39fdf4.png";